import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, EventEmitter, Inject, NgZone, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, RequiredValidator, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';
import { ContractService } from 'src/app/contract/shared/contract.service';
import { TotalRecordCountService } from '../result-search/total-record-count.service';
import { KpiService } from './kpi.service';
@Component({
  selector: 'app-kpi-dialog',
  templateUrl: './kpi-dialog.component.html',
  styleUrl: './kpi-dialog.component.css'
})
export class KpiDialogComponent {
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  kpiForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;
  totalRecordCount: number = 0;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private toast: ToastrService, private dialog: MatDialog, private contractService: ContractService, private _ngZone: NgZone,private totalRecordCountService: TotalRecordCountService, private kpiService :KpiService , private dialogRef: MatDialogRef<KpiDialogComponent>) {
    this.kpiForm = new FormGroup({
      kpiName: new FormControl('',[Validators.required] ),
      count :new FormControl ('')
    });
  }
  ngOnInit(): void {
    this.totalRecordCountService.getTotalRecordCount().subscribe((count) => {
      this.totalRecordCount = count;
      this.kpiForm.patchValue({ count: this.totalRecordCount });
    });
  }
  triggerResize() {
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }
  async saveKpi() {
    if (this.kpiForm.valid) {
      const formData = this.kpiForm.value;
      this.kpiService.saveKpiData(formData);
      // Reset the form after saving
      this.kpiForm.reset();
      this.dialogRef.close();
    }
  }

  get kpiData() {
    return this.kpiService.getKpiData();
  }
}
